import { atom } from 'jotai';
import type { OpsFeedsSearchModel } from './feeds_search_types';
import { feedsSearchStateVM } from './feeds_search_view_models';

export const feedsSearchFormAtom = atom<OpsFeedsSearchModel>(feedsSearchStateVM());
